import { hasQuestionContent, validationError } from './practiceModel';
import { validQuestionNumber } from './voiceCommands';

export const OTQ_TYPES = { mcq: 'Multiple choice', dropdown: 'Dropdown', 'short-answer': 'Number / short answer', matching: 'Matching pairs', 'mcq-grid': 'Multiple choice grid' };
export function blankRequirement(type = 'mcq') {
    return { type, text: '', images: [], options: type === 'matching' ? ['', ''] : ['', '', '', ''], prompts: ['', ''], rows: ['', ''], columns: ['', ''],
        correctAnswer: type === 'mcq' ? [] : ['matching', 'mcq-grid'].includes(type) ? {} : '', marks: 2, questionNumber: '', explanation: '', explanationFormat: 'text' };
}
export function blankScenario() {
    return { title: '', topic: '', text: '', images: [], difficulty: 'standard', bunnyLibraryId: '', bunnyVideoId: '', parts: Array.from({ length: 5 }, () => blankRequirement()) };
}
export function scenarioValidation(draft) {
    if (!String(draft.title || '').trim()) return { message: 'Give this scenario a title.', tab: 0 };
    if (!String(draft.topic || '').trim()) return { message: 'Choose a topic for this scenario.', tab: 0 };
    if (!hasQuestionContent(draft)) return { message: 'Add the shared scenario text or an image.', tab: 0 };
    if (draft.bunnyVideoId && !draft.bunnyLibraryId) return { message: 'The video needs a video library. Remove it or check the video settings.', tab: 0 };
    if (draft.parts?.length !== 5) return { message: 'A Section B scenario needs exactly five requirements.', tab: 0 };
    const numbers = new Set();
    for (let i = 0; i < draft.parts.length; i++) {
        const part = draft.parts[i];
        const problem = !OTQ_TYPES[part.type] ? 'Choose an objective question format.' : validationError(part, draft.topic);
        if (problem) return { message: `Requirement ${i + 1}: ${problem}`, tab: i + 1 };
        const number = validQuestionNumber(part.questionNumber);
        if (part.questionNumber !== '' && part.questionNumber != null && !number) return { message: `Requirement ${i + 1}: Use a question number from 1 to 9999, or leave it blank.`, tab: i + 1 };
        if (number && numbers.has(number)) return { message: `Requirement ${i + 1}: Each question number must be unique.`, tab: i + 1 };
        if (number) numbers.add(number);
    }
    return null;
}
